import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions";
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/query/react";

import {
  LoginRequest,
  VerifyAccountRequest,
  ForgotPasswordRequest,
  UpdatePasswordRequest,
  VerifyPasswordRequest,
} from "api/types/requests";
import User from "api/types/models/user";
import QueryTags from "api/types/QueryTags";
import Practice from "api/types/models/practice";
import ResendVerifyRequest from "api/types/requests/auth/resend_verify";

const authEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      {},
      FetchBaseQueryMeta
    >,
    QueryTags,
    "data"
  >,
) => ({
  getMe: builder.query<{ user: User; practice: Practice }, void>({
    query: () => "/auth/me",
    providesTags: ["AuthMe"],
  }),

  login: builder.mutation<{ user: User; practice: Practice }, LoginRequest>({
    query: (body) => ({
      url: "/auth/local/login",
      method: "post",
      body,
    }),
  }),

  logout: builder.mutation<void, void>({
    query: () => ({
      url: "/auth/local/logout",
      method: "post",
    }),
  }),

  verifyPassword: builder.mutation<void, VerifyPasswordRequest>({
    query: (body) => ({
      url: "/password/verify",
      method: "post",
      body,
    }),
  }),

  forgotPassword: builder.mutation<void, ForgotPasswordRequest>({
    query: (body) => ({
      url: "/password/forgot",
      method: "post",
      body,
    }),
  }),

  updatePassword: builder.mutation<void, UpdatePasswordRequest>({
    query: (body) => ({
      url: "/password/update",
      method: "put",
      body,
    }),
  }),

  verifyAccount: builder.mutation<
    { user: User; practice: Practice },
    VerifyAccountRequest
  >({
    query: (body) => ({
      url: "/auth/verify",
      method: "post",
      body,
    }),
  }),

  resendVerify: builder.mutation<void, ResendVerifyRequest>({
    query: ({ id }) => ({
      url: "/auth/verify/resend",
      method: "post",
      params: {
        id,
      },
    }),
  }),

  getHeartbeat: builder.query<void, void>({
    query: () => "/auth/heartbeat",
  }),
});

export default authEndpoints;
